import styled from "styled-components";
import { BREAKPOINTS } from "shared/hooks/useBreakpoint";

export const Page = styled.div`
  min-height: 100vh;
  background: ${({ theme }) => theme.colors.pageGray};
`;

export const HeaderArea = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border-bottom: 1px solid ${({ theme }) => theme.colors.dividerGray};
  min-height: 3.7rem;

  @media (min-width: ${BREAKPOINTS.lg}px) {
    min-height: 0;
  }
`;

export const Content = styled.main`
  width: calc(100% - 32px);
  margin: 0 auto;
  padding: ${({ theme }) => theme.spacing(5)} 0 ${({ theme }) => theme.spacing(10)};

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    width: 80%;
  }
`;

export const Title = styled.h1`
  color: ${({ theme }) => theme.colors.deepDarkBlue};
  font-size: ${({ theme }) => theme.fontSizes.xl};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  margin-bottom: ${({ theme }) => theme.spacing(6)};
`;

export const BackLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  color: ${({ theme }) => theme.colors.white};
  text-decoration: none;
  font-size: ${({ theme }) => theme.fontSizes.sm};
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  margin-bottom: ${({ theme }) => theme.spacing(4)};
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.white};
    outline-offset: 3px;
  }
`;

export const StateMessage = styled.div`
  text-align: center;
  padding: ${({ theme }) => theme.spacing(8)};
  color: ${({ theme }) => theme.colors.darkGray};
`;

export const StateTitle = styled.h2`
  color: ${({ theme }) => theme.colors.deepDarkBlue};
  font-size: ${({ theme }) => theme.fontSizes.lg};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;

export const StateHint = styled.p`
  color: ${({ theme }) => theme.colors.darkGray};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  margin-bottom: ${({ theme }) => theme.spacing(4)};
`;

export const SectionLabel = styled.h2`
  color: ${({ theme }) => theme.colors.deepDarkBlue};
  font-size: ${({ theme }) => theme.fontSizes.lg};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  margin-bottom: ${({ theme }) => theme.spacing(4)};
`;

export const ListGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${({ theme }) => theme.spacing(5)};

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`;

export const LoadMoreRow = styled.div`
  margin-top: ${({ theme }) => theme.spacing(5)};
  text-align: center;
`;

export const DialogActions = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(3)};
`;

/**
 * Alinha as seções de conteúdo abaixo da lista (FAQ) à largura da lista e do
 * banner (80% no desktop). Zera o padding horizontal do Section interno.
 */
export const InfoWidth = styled.div`
  width: calc(100% - 32px);
  margin: 0 auto;

  & > section {
    padding-left: 0;
    padding-right: 0;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    width: 80%;
  }
`;
